/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyListSummary
 */
export interface CompanyListSummary {
  /**
   *
   * @type {string}
   * @memberof CompanyListSummary
   */
  companyListId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyListSummary
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CompanyListSummary
   */
  ownerEmail: string;
  /**
   *
   * @type {number}
   * @memberof CompanyListSummary
   */
  itemCount: number;
  /**
   *
   * @type {number}
   * @memberof CompanyListSummary
   */
  doneCount: number;
  /**
   *
   * @type {boolean}
   * @memberof CompanyListSummary
   */
  isOwner: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CompanyListSummary
   */
  isFollowing: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyListSummary
   */
  followers: Array<string>;
}

/**
 * Check if a given object implements the CompanyListSummary interface.
 */
export function instanceOfCompanyListSummary(
  value: object,
): value is CompanyListSummary {
  if (!("companyListId" in value) || value["companyListId"] === undefined)
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("ownerEmail" in value) || value["ownerEmail"] === undefined)
    return false;
  if (!("itemCount" in value) || value["itemCount"] === undefined) return false;
  if (!("doneCount" in value) || value["doneCount"] === undefined) return false;
  if (!("isOwner" in value) || value["isOwner"] === undefined) return false;
  if (!("isFollowing" in value) || value["isFollowing"] === undefined)
    return false;
  if (!("followers" in value) || value["followers"] === undefined) return false;
  return true;
}

export function CompanyListSummaryFromJSON(json: any): CompanyListSummary {
  return CompanyListSummaryFromJSONTyped(json, false);
}

export function CompanyListSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyListSummary {
  if (json == null) {
    return json;
  }
  return {
    companyListId: json["companyListId"],
    name: json["name"],
    ownerEmail: json["ownerEmail"],
    itemCount: json["itemCount"],
    doneCount: json["doneCount"],
    isOwner: json["isOwner"],
    isFollowing: json["isFollowing"],
    followers: json["followers"],
  };
}

export function CompanyListSummaryToJSON(json: any): CompanyListSummary {
  return CompanyListSummaryToJSONTyped(json, false);
}

export function CompanyListSummaryToJSONTyped(
  value?: CompanyListSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListId: value["companyListId"],
    name: value["name"],
    ownerEmail: value["ownerEmail"],
    itemCount: value["itemCount"],
    doneCount: value["doneCount"],
    isOwner: value["isOwner"],
    isFollowing: value["isFollowing"],
    followers: value["followers"],
  };
}
